import { createSelector } from "reselect";
import { getLevelGroup } from "./levelGroupSelectors";
import orderByPosition from "./helpers/orderByPosition";

export const getLevels = (state) => state.entities.levels;
export const getLevel = (_, props) => props.level;

export const getLevelsByLevelGroup = createSelector(
  getLevelGroup,
  getLevels,
  (levelGroup, levels) =>
    levels &&
    Object.values(levels)
      .filter((level) => level.levelGroupId === levelGroup.id)
      .sort(orderByPosition)
);
